import React from "react";
import { SponsorDetailsContainer } from "../../../containers";

const SponsorDetails = (props) => {
  return <SponsorDetailsContainer {...props} />;
};

export default SponsorDetails;
